import './assets/style/reset.css'// 重置文件
import 'element-ui/lib/theme-chalk/index.css';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import moment from 'moment'
import comFooter from './components/footer.vue'
import comHead from './components/comHeader.vue'
Vue.component('comFooter', comFooter)
Vue.component('comHead', comHead)
Vue.prototype.$moment = moment;
Vue.use(ElementUI);
// console.log(process);
import VideoPlayer from 'vue-video-player'

// 适配
import 'px2rem-loader';
import 'postcss-px2rem';
import './utils/rem.js';

Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.prototype.$urlPrefix = process.env.VUE_APP_URL;
Vue.prototype.$urlFile = process.env.VUE_APP_FILE_URL;

// import axios from './request/axios.js';
// import VueAxios from 'vue-axios'

// Vue.use(axios);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
